module.exports = __webpack_public_path__ + "static/media/googlePNG.250d4530.png";